import { useProductDetailModalStore } from "../store/product-detail-modal-store";

/**
 * Product Detail Modal Hook
 *
 * Provides easy access to product detail modal functionality:
 * - Open modal with product ID
 * - Close modal
 * - Check if modal is open
 */

export const useProductDetailModal = () => {
  const { isOpen, productId, offerId, openModal, closeModal } =
    useProductDetailModalStore();

  return {
    // State
    isOpen,
    productId,
    offerId,

    // Actions
    openModal,
    closeModal,
  };
};
